import { useEffect, useSyncExternalStore, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { dismissToast, toastStore, type ToastItem } from '../../lib/toast.js';
import { Icon } from '../../lib/icons.js';

const ICON: Record<ToastItem['tone'], string> = { info: 'info', positive: 'check', caution: 'alert', alert: 'alert' };

function ToastView({ t }: { t: ToastItem }): ReactNode {
  useEffect(() => {
    const id = window.setTimeout(() => dismissToast(t.id), t.ttl);
    return () => window.clearTimeout(id);
  }, [t.id, t.ttl]);
  return (
    <div className="toast glass glass-raised" role={t.tone === 'alert' ? 'alert' : 'status'} data-tone={t.tone}>
      <Icon name={ICON[t.tone]} size={17} />
      <span className="toast-msg">{t.message}</span>
      {t.action && (
        <button
          type="button"
          className="toast-action"
          onClick={() => {
            t.action?.run();
            dismissToast(t.id);
          }}
        >
          {t.action.label}
        </button>
      )}
      <button type="button" className="toast-close" aria-label="Dismiss" onClick={() => dismissToast(t.id)}>
        <Icon name="close" size={13} />
      </button>
    </div>
  );
}

export function ToastHost(): ReactNode {
  const items = useSyncExternalStore(toastStore.subscribe, toastStore.get, toastStore.get);
  return createPortal(
    <div className="toast-stack" aria-live="polite">
      {items.map((t) => (
        <ToastView key={t.id} t={t} />
      ))}
    </div>,
    document.body,
  );
}
